import { getCurrentFocusKey } from "@noriginmedia/norigin-spatial-navigation"
import { LoadRequestData } from "chromecast-caf-receiver/cast.framework.messages"
import { useEffect } from "react"

import useSdk from "../hooks/use-sdk"
import { useAuth } from "../store/AppStore"
import { PlaybackContent, playerStore } from "../store/PlayerStore"

import { Platform, platform } from "./constants"

type DGPayLoad = {
  contentId: string
  contentType: "audio" | "video"
  subtype?: "SUBTITLE_LANGUAGE" // .. or other types
  token: string
  refreshToken: string
  locale: string
  isTrailer?: boolean
  trackId?: string
  subtitleLanguage?: string
  startTime?: number
  // used for debugging
  direct_play_url?: string
}

export interface CustomMessagePayload extends LoadRequestData {
  customData: DGPayLoad
}

export const useChromecastListener = () => {
  const { storeTokens } = useAuth()
  const setContent = playerStore((state) => state.setContent)
  const setNavigationProps = playerStore((state) => state.setNavigationProps)
  const navigationProps = playerStore((state) => state.navigationProps)
  const setReturnFocus = playerStore((state) => state.setReturnFocus)
  const sdk = useSdk()
  const handler = async (
    customEvent: CustomEventInit<{ media: CustomMessagePayload }>,
  ) => {
    // if not chromecast => no-op
    if (platform !== Platform.Chromecast) return
    // we assume the debugger is initialized if we made it this far

    const castDebugLogger = cast.debug.CastDebugLogger.getInstance()
    castDebugLogger.info("StagePlus.LOG", "entered zone", customEvent.detail)

    const data = customEvent.detail
    if (!data) return
    const payload = data.media as CustomMessagePayload
    if (payload?.customData?.token && payload?.customData?.refreshToken)
      storeTokens({
        accessToken: payload.customData.token,
        refreshToken: payload.customData.refreshToken,
      })
    // wait for tokens to be set
    setTimeout(async () => {
      const content = (
        payload.customData.contentType === "video"
          ? (
              await sdk.videoDetailPage({
                videoId: payload?.customData?.contentId,
              })
            ).node
          : payload.customData.contentType === "audio"
            ? (
                await sdk.audioDetailPage({
                  albumId: payload?.customData?.contentId,
                })
              ).album
            : undefined
      ) as PlaybackContent
      if (!navigationProps.open) setReturnFocus(getCurrentFocusKey())
      setContent(undefined)
      setNavigationProps({ open: false })
      setTimeout(() => {
        setContent(content as PlaybackContent)
        setNavigationProps({
          open: true,
          id: content?.id,
          type: content?.__typename,
          isPreview: "false",
          trackId: "0",
          startFromProgress: true,
        })
      }, 100)
    }, 200)
  }
  useEffect(() => {
    window.addEventListener("castMessage", handler)
    return () => window.removeEventListener("castMessage", handler)
  }, [])

  return null
}
